import { inject, Injectable } from '@angular/core';
import { BaseWooCommerceV3RestaurantApiService } from './base-woo-commerce-v3-restaurant-api.service';
import { map, Observable, tap } from 'rxjs';
import { WooCommerceRestaurant } from '../../../interfaces/woo-commerce/api/restaurant/restaurant-api.interface';
import { mapHappyStoreInfoToWooRestaurant } from '../../happy/happy-api-mappers';
import { HappyStoreInfoCacheService } from '../../happy/happy-store-info-cache.service';
import { HappyStoreSelectionService } from '../../happy/happy-store-selection.service';

@Injectable({
  providedIn: 'root'
})
export class WooCommerceRestaurantApiService extends BaseWooCommerceV3RestaurantApiService {
  private readonly happyStoreUrl: string = '/store/info';

  private readonly storeInfoCache = inject(HappyStoreInfoCacheService);
  private readonly happyStoreSelection = inject(HappyStoreSelectionService);

  getRestaurantInfo(): Observable<WooCommerceRestaurant> {
    return this.get<any>(this.happyStoreUrl).pipe(
      map((response: any) => {
        const store = response?.data || response || {};
        return mapHappyStoreInfoToWooRestaurant(store);
      }),
      tap((payload: WooCommerceRestaurant) => {
        const storeApiKey =
          this.happyStoreSelection.getSelected()?.storeApiKey || null;
        this.storeInfoCache.set(storeApiKey, payload);
      })
    );
  }
}
